import axios from "@axios";
import { ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function useQuoteValidation() {
  const toast = useToast();
  const isLoading = ref(false);
  const validationStatus = ref(null);

  /**
   * Notifie le client pour valider le devis
   * @param {string} opportunityId - ID du Opportunity
   * @returns {Promise}
   */
  const notifyCustomer = async (opportunityId) => {
    isLoading.value = true;
    try {
      const { data, status } = await axios.post(
        `/finances/budget-tracking/${opportunityId}/notify-customer`,
        {},
        {
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
          },
        }
      );

      if (status === 200) {
        toast({
          component: ToastificationContent,
          props: {
            title: "Notification envoyée",
            text: data.message || "Le client a été notifié avec succès",
            icon: "CheckCircleIcon",
            variant: "success",
          },
        });
        return data;
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Erreur lors de l'envoi de la notification";
      toast({
        component: ToastificationContent,
        props: {
          title: "Erreur",
          text: errorMessage,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  /**
   * Retrieves the quote validation status
   * @param {string} opportunityId - Opportunity ID
   * @returns {Promise}
   */
  const getValidationStatus = async (opportunityId) => {
    isLoading.value = true;
    try {
      const { data, status } = await axios.get(
        `/finances/budget-tracking/${opportunityId}/validation-status`,
        {
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json",
          },
        }
      );

      if (status === 200) {
        validationStatus.value = data;
        return data;
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du statut:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    validationStatus,
    notifyCustomer,
    getValidationStatus,
  };
}
